// Internationalization
export const CHANGE_INTL_SUCCESS = 'CHANGE_INTL_SUCCESS';



// WEBPACK FOOTER //
// ./src/actions/intl-actions.js